import {
  ValidationPopupContentDescription,
  ValidationPopupContentTitle,
  ValidationPopupErrorMessage,
} from "../atoms";
import { ValidationPopupArrows } from "../molecules";

export const ValidationPopupContent = ({
  titleText,
  contentMessageText,
  errorMessageText,
}: {
  titleText: string;
  contentMessageText: string;
  errorMessageText: string;
}) => {
  return (
    <>
      <ValidationPopupContentTitle titleText={titleText} />
      <ValidationPopupContentDescription
        contentMessageText={contentMessageText}
      />
      <ValidationPopupArrows />
      <ValidationPopupErrorMessage errorMessageText={errorMessageText} />
    </>
  );
};
